import { useRef, useState } from 'react';
import { formatDate } from '../../../../lib/utils';
import { ReactComponent as PhotoSvg } from '../../../../assets/svg/img.svg';
import ViewLog from './viewLog';

const BodyLogBook = ({ logs, refresh, openCreateDialog }) => {
  const viewDialogRef = useRef(null);

  const [selectedLog, setSelectedLog] = useState({});

  const handleSelectLog = (item) => () => {
    setSelectedLog(item);
    openViewDialog();
  };

  const openViewDialog = () => {
    if (viewDialogRef.current) {
      viewDialogRef.current.showModal();
    }
  };

  const closeViewDialog = () => {
    if (viewDialogRef.current) {
      setSelectedLog({});
      viewDialogRef.current.close();
    }
  };

  return (
    <>
      <div className='space-y-2'>
        <div className='flex justify-between items-center'>
          <div className='font-bold text-white'>Log Book</div>
          <button
            onClick={openCreateDialog}
            className='size-8 flex justify-center items-center text-white bg-tertiary rounded-full'
          >
            +
          </button>
        </div>
        {logs.map((item, i) => (
          <div key={item ? item.id : `key-${i}`}>
            <div className='text-xs mb-2 font-semibold text-white'>
              {item && item.logDate === formatDate(new Date())
                ? 'Today'
                : item
                ? item.logDate
                : null}
            </div>
            <div
              className='grid grid-cols-3 gap-1'
              onClick={handleSelectLog(item)}
            >
              <div className='border border-tertiary rounded-xl relative aspect-square flex justify-center items-center overflow-hidden'>
                {item.frontPhotoUrl ? (
                  <img
                    src={item.frontPhotoUrl}
                    alt=''
                    className={`object-cover w-full h-full`}
                  />
                ) : (
                  <div className='w-full h-full flex justify-center items-center opacity-10'>
                    <PhotoSvg
                      className='size-8'
                      fill='white'
                    />
                  </div>
                )}
                <div
                  className={`absolute top-1 left-1 bg-black bg-opacity-60 text-white rounded-full px-1 text-xs ${
                    !item.frontPhotoUrl && 'opacity-30'
                  }`}
                >
                  Front
                </div>
              </div>
              <div className='border border-tertiary rounded-xl relative aspect-square flex justify-center items-center overflow-hidden'>
                {item.sidePhotoUrl ? (
                  <img
                    src={item.sidePhotoUrl}
                    alt=''
                    className={`object-cover w-full h-full`}
                  />
                ) : (
                  <div className='w-full h-full flex justify-center items-center opacity-10'>
                    <PhotoSvg
                      className='size-8'
                      fill='white'
                    />
                  </div>
                )}
                <div
                  className={`absolute top-1 left-1 bg-black bg-opacity-60 text-white rounded-full px-1 text-xs ${
                    !item.sidePhotoUrl && 'opacity-30'
                  }`}
                >
                  Side
                </div>
              </div>
              <div className='border border-tertiary rounded-xl relative aspect-square flex justify-center items-center overflow-hidden'>
                {item.backPhotoUrl ? (
                  <img
                    src={item.backPhotoUrl}
                    alt=''
                    className={`object-cover w-full h-full`}
                  />
                ) : (
                  <div className='w-full h-full flex justify-center items-center opacity-10'>
                    <PhotoSvg
                      className='size-8'
                      fill='white'
                    />
                  </div>
                )}
                <div
                  className={`absolute top-1 left-1 bg-black bg-opacity-60 text-white rounded-full px-1 text-xs ${
                    !item.backPhotoUrl && 'opacity-30'
                  }`}
                >
                  Back
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ViewLog
        viewDialogRef={viewDialogRef}
        log={selectedLog}
        closeDialog={closeViewDialog}
        refresh={refresh}
      />
    </>
  );
};

export default BodyLogBook;
